import React, { useEffect, useState } from "react";
import SampleScanned from "./checkin/sampleScanned";
import { GetUsers } from "../services/usersService";
import Scanner from "./common/scanner";
import { NotificationManager } from "react-notifications";

export default function Main() {
	const [scan, setScan] = useState("");
	const [webUrl, setWebUrl] = useState("");
	const [users, setUsers] = useState([]);

	useEffect(() => {
		async function loadUsers() {
			let u = await GetUsers("SHIPPING");
			setUsers(u);
		}
		try {
			loadUsers();
		} catch (err) {
			NotificationManager.error("Error getting the list of users from the API");
		}
	}, []);

	useEffect(() => {
		if (webUrl !== "") {
			console.log('webUrl',webUrl)
			window.open(webUrl, '_blank', 'noreferrer');
			// window.location.href = webUrl;
			//const newTab = window.open(webUrl, "_blabnk");
			// setWebUrl("");
			///if (newTab) {
				//newTab.focus();
			  //} else {
				///console.error("Failed to open new tab.");
				//NotificationManager.error("Failed to open URL in new tab.");
			  //}
		}
	}, [scan]);

	const onScan = (scanData) => {
		if (scanData.includes("Order Number:")) {
			const orderNumberRegex = /Order Number: (\d+)/;
			const orderNumberMatch = scanData.match(orderNumberRegex);
			const scannedOrderNumber = orderNumberMatch ? orderNumberMatch[1] : "";
			const webLinkRegex = /Web Link: (https?:\/\/\S+)/;
			const webLinkMatch = scanData.match(webLinkRegex);
			const webUrlScanned = webLinkMatch ? webLinkMatch[1] : "";

			// Opening the web link in a new tab
			if (webUrlScanned !== "") {
				setWebUrl(webUrlScanned);
			}

			setScan(scannedOrderNumber);
		} else {
			setScan(scanData);
		}
	};

	  

	const clearScan = () => {
		setWebUrl("")
		setScan("");
	};

	const renderScanner = () => {
		return (
			<div className="footer">
				<div className="columns">
					<div className="column is-centered">
						{!scan ? (
							<>
							<div className="column">
								<Scanner onScan={onScan} />
							</div>
							</>
						) : (
							<> </>
						)}
					</div>
				</div>
			</div>
		);
	};

	const renderInputFields = () => {
		return (
			<SampleScanned scanData={scan} users={users} clearScan={clearScan} webUrl={webUrl} />
		);
	};

	return <>{!scan ? renderScanner() : renderInputFields()}</>;
}
